import {
    UserAction,UserState,ADD_FIRSTNAME,ADD_LASTNAME,ADD_ID,ADD_ROL,
  } from "./types";
  
  const initialStateUser: UserState = {
    id: '',
    organizationid:'',
    type: '',
    identificaton:'',
    firstname: '',
    lastname: '',
    email: '',
    rol:'',
    phone: '',
    position:'',
    area:'',
    birthday: '',
    status: ''
  }




  
  
export function userReducer(
  state = initialStateUser,
  action: UserAction
): UserState {
  switch (action.type) {
    case ADD_FIRSTNAME:
      return {
        ...state,
        firstname: action.payload
      };
    case ADD_LASTNAME:
      return {
        ...state,
        lastname: action.payload
      };
      case ADD_ID:
        return {
          ...state,
          id: action.payload
        };
        case ADD_ROL:
          return {
            ...state,
            rol: action.payload
          };
    default:
      return state;
  }
}